import { useCallback, useEffect, useState } from 'react'

export const useOnlineStatus = (): boolean => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const onOnline = useCallback(() => {
    setIsOnline(true)
  }, [])
  const onOffline = useCallback(() => {
    setIsOnline(false)
  }, [])

  useEffect(() => {
    window.addEventListener('online', onOnline)
    window.addEventListener('offline', onOffline)
    return () => {
      window.removeEventListener('online', onOnline)
      window.removeEventListener('offline', onOffline)
    }
  }, [onOnline, onOffline])

  return isOnline
}
